import { FC } from "react";
import { Field, FieldRenderProps, useField } from "react-final-form";

import { FormField, Input } from "@livechat/design-system-react-components";

import { Divider } from "components/divider/Divider";
import Flex from "components/layout/Flex";
import { IFormBlockTextarea } from "store/entities/contact-forms/interfaces";

import { RequiredErrorField } from "./parts/RequiredErrorField";

interface IProps {
  name: string;
}

export const MessageBlock: FC<IProps> = ({ name }) => {
  return <Field name={name} component={MessageBlockInput} />;
};

const MessageBlockInput: FC<FieldRenderProps<IFormBlockTextarea>> = ({ input }) => {
  const isRequired = useField(input.name).input.value.required;

  return (
    <Flex column>
      <Field name={`${input.name}.value`}>
        {({ input, meta }) => (
          <FormField labelText="Message field label" error={meta.error}>
            <Input {...input} error={meta.error} data-testid="textarea-input-label" />
          </FormField>
        )}
      </Field>
      {isRequired && (
        <>
          <Divider />
          <Field name={`${input.name}.requiredError`} render={RequiredErrorField} blockType="textarea" />
        </>
      )}
    </Flex>
  );
};
